import { Controller } from '@hotwired/stimulus'

/**
 * Compare Highlight Controller
 *
 * Highlights matching specification rows across all product comparison cards
 * when hovering or clicking on a row. Helps users compare the same spec
 * across different products.
 *
 * Usage:
 *   <div data-controller="compare-highlight">
 *     <tr data-compare-highlight-target="row" data-spec="material_type">...</tr>
 *   </div>
 */
export default class extends Controller {
  static targets = ['row']

  connect() {
    this.lockedSpec = null
  }

  highlight(event) {
    // Don't override a locked highlight on hover
    if (this.lockedSpec) return

    const spec = event.currentTarget.dataset.spec
    this.highlightSpec(spec)
  }

  unhighlight() {
    // Don't clear if we have a locked highlight
    if (this.lockedSpec) return

    this.clearHighlights()
  }

  toggle(event) {
    const spec = event.currentTarget.dataset.spec

    if (this.lockedSpec === spec) {
      // Clicking the same row again unlocks it
      this.lockedSpec = null
      this.clearHighlights()
    } else {
      // Lock this spec
      this.lockedSpec = spec
      this.highlightSpec(spec)
    }
  }

  highlightSpec(spec) {
    this.rowTargets.forEach(row => {
      if (row.dataset.spec === spec) {
        row.classList.add('compare-highlight')
      } else {
        row.classList.remove('compare-highlight')
      }
    })
  }

  clearHighlights() {
    this.rowTargets.forEach(row => {
      row.classList.remove('compare-highlight')
    })
  }
}
